<ng-container [formGroup]="deliverableForm">
    <h3 class="form-header" mat-dialog-title i18n="@@8503537432701834743" t="8503537432701834743"
        >Reorder Deliverables</h3
    >

    <div class="grid">
        <div class="row">
            <div fxFlex="50">
                <tsl-form-field fxFlex="95">
                    <tsl-label i18n="@@2856849763333639424" t="2856849763333639424">Sort By*</tsl-label>
                    <tsl-select formControlName="sortByType" fxFlex="95">
                        <tsl-option [value]="0" i18n="@@Manual" t="Manual">Manual</tsl-option>
                        <tsl-option [value]="1" i18n="@@Column" t="Column">Column</tsl-option>
                    </tsl-select>
                </tsl-form-field>
            </div>
            <div fxFlex="50" *ngIf="sortByManual">
                <tsl-form-field fxFlex="95">
                    <tsl-label i18n="@@8919773257479619060" t="8919773257479619060">Event*</tsl-label>
                    <tsl-select formControlName="eventType" (selectionChange)="getSelectedDeliverableArray($event)">
                        <tsl-option [value]="0" i18n="@@Design" t="Design">Design</tsl-option>
                        <tsl-option [value]="1" i18n="@@Build" t="Build">Build</tsl-option>
                        <tsl-option [value]="2" i18n="@@Commission" t="Commission">Commission</tsl-option>
                        <tsl-option [value]="3" i18n="@@Maintenance" t="Maintenance">Maintenance</tsl-option>
                    </tsl-select>
                </tsl-form-field>
            </div>
            <div fxFlex="50" *ngIf="!sortByManual">
                <tsl-form-field fxFlex="95">
                    <tsl-label i18n="@@6391848608863625661" t="6391848608863625661">Column*</tsl-label>
                    <tsl-select formControlName="columnType" (selectionChange)="sortByDate($event)">
                        <tsl-option
                            [value]="0"
                            i18n="@@3e6acd589d8b82cafd8546409da0a36469d297a0"
                            t="3e6acd589d8b82cafd8546409da0a36469d297a0"
                            >Start Date</tsl-option
                        >
                        <tsl-option
                            [value]="1"
                            i18n="@@4d961692683b8c12d806cc44691277aeeade42e5"
                            t="4d961692683b8c12d806cc44691277aeeade42e5"
                            >Planned Date</tsl-option
                        >
                        <tsl-option
                            [value]="2"
                            i18n="@@363815f9ef9291da0b2a6f2a9322751e0d9dbaf6"
                            t="363815f9ef9291da0b2a6f2a9322751e0d9dbaf6"
                            >Actual Date</tsl-option
                        >
                    </tsl-select>
                </tsl-form-field>
            </div>
        </div>
    </div>

    <div>
        <tsl-label
            *ngIf="hasSelectedDeliverables && sortByManual"
            i18n="@@1349768408073861077"
            t="1349768408073861077"
            >Rearrange the table by dragging and dropping rows</tsl-label
        >
        <cdk-virtual-scroll-viewport style="height: 250px" itemSize="90">
            <table class="table" *ngIf="hasSelectedDeliverables && sortByManual">
                <thead>
                    <tr>
                        <th scope="col" i18n="@@Deliverable" t="Deliverable">Deliverable</th>
                    </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="onDrop($event)">
                    <tr *ngFor="let del of selectedEventDeliverables" cdkDrag cdkDragLockAxis="y">
                        <div *ngIf="hasDeliverable(del)">
                            <th class="col-xs">
                                <div class="drag-handle">
                                    <ng-container [ngTemplateOutlet]="dragHandleTmpl"> </ng-container>
                                    {{ del.deliverable }}
                                </div>
                            </th>
                        </div>
                    </tr>
                </tbody>
            </table>
        </cdk-virtual-scroll-viewport>
    </div>

    <div class="right" style="padding-top: 15px">
        <button tsl-button outline color="black" size="small" (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button tsl-button filled color="blue" size="small" (click)="onSave()" i18n="@@Submit" t="Submit"
            >Submit</button
        >
    </div>
</ng-container>
